export default __webpack_public_path__ + "static/media/bg1.6e2ca2e6.jpeg";